import styled from '@emotion/styled'
import {Box, Popover, Typography} from '@mui/material'

export const TruncatedTextContainer = styled(Box)(({theme}) => ({
  fontSize: theme.typography.body1.fontSize,
  color: theme.palette.hpBlack,
  padding: theme.spacing(1),
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  minWidth: 0,
  maxWidth: '100%',
  display: 'block'
}))

export const TruncatedTextPopover = styled(Popover)(() => ({
  pointerEvents: 'none',
  '& .MuiPaper-root': {
    minWidth: '280px',
    maxWidth: '640px'
  }
}))

export const TruncatedTextPopoverContent = styled(Typography)(({theme}) => ({
  padding: theme.spacing(1.25),
  whiteSpace: 'pre-wrap',
  overflowWrap: 'anywhere'
}))
